var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',_vm._l((_vm.automezzi),function(mezzo){return _c('AutomezzoEl',{key:mezzo.id,attrs:{"automezzo":mezzo}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }